import { Box, Button, IconButton, Typography } from '@mui/material';
import { Close } from '@mui/icons-material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { RaterStyles } from '../../styles/rater';
import RaterHelpStyles from '../../styles/raterNominationHelp';
import { WCAGStrandardStyles } from '../../../common/styles/WCAGStandardStyles';

export interface RaterNominationHelpProps {
  toolTip: string;
  heading: string;
  categories: Categories[];
  close: () => void;
}

interface Categories {
  subHead: string;
  desc: string;
}

const populateCategories = (data: Categories[]): React.JSX.Element => {
  const { classes } = RaterHelpStyles();
  return (
    <>
      {data.map((cat, index) => {
        return (
          <Box key={index} className={classes.marginTop24px}>
            <Typography className={classes.subHeading}>{cat.subHead}</Typography>
            <Typography className={classes.desc}>{cat.desc}</Typography>
          </Box>
        );
      })}
    </>
  );
};

const RaterNominationHelp = (props: RaterNominationHelpProps): React.JSX.Element => {
  const { classes: rc } = RaterStyles();
  const { classes } = RaterHelpStyles();
  const { t } = useTranslation();
  const { classes: WCAGClasses } = WCAGStrandardStyles();

  return (
    <Box className={classes.root}>
      <Box id="heading" className={`${rc.fullWidth} ${rc.inlineFlex}`}>
        <Typography className={`${classes.heading} ${WCAGClasses.h5}`}>{props.heading}</Typography>
        <IconButton className={classes.closeButton} onClick={(): void => props.close()}>
          <Close />
        </IconButton>
      </Box>
      <Box id="categories">{populateCategories(props.categories)}</Box>
      <Box className={classes.okButton}>
        <Button className={`${rc.doneButton} ${rc.width100}`} aria-label={t('ok')} onClick={(): void => props.close()}>
          {t('ok')}
        </Button>
      </Box>
    </Box>
  );
};

export default RaterNominationHelp;
